export function getAuthConfig(token, config = {}) {
    const headers = {
        ...(config.headers || {}),
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    return {
        ...config,
        headers,
    };
}
